module.exports = __webpack_public_path__ + "static/piclife_title-17967269439742de9ab23455cf36cdd6.png";